import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import Switch from "../../../../Switch";
import { jsx as _jsx } from "react/jsx-runtime";
function SwitchCell(_ref) {
  var restProps = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(Switch, _extends({}, restProps));
}
SwitchCell.displayName = "SwitchCell";
export default SwitchCell;